import axios from 'axios'
import { DateTime } from 'luxon'
import { petFromIccid } from '../helpers/petHelper.tsx'
import { isLocationValid } from '../helpers/locationStatusHelper.ts'
import { findIsWaitingOnTracker, recordFindResponse } from '../interfaces/findState.ts'
import { authState } from '../store/authState.ts'
import { dataState, setLastLocation, setLastReport, updateDeviceStatus, setLastEvent } from '../store/dataState.ts'
import { setFindInProgress, setFindStatus } from '../store/findState.ts'

export const getUserIPaddress  = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json")
    authState.userIP = res.data.ip;
};


export const processGibiMessage = (message: any) => {
    const date = DateTime.now().setZone(authState.timezone.value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
    switch (message.type) {
        case 'POSITION_UPDATE': {
            if (isLocationValid(message.locationReport.properties)) {
                setLastLocation(message.iccid, message.locationReport)
            } else {
                setLastReport(message.iccid, message.locationReport)
            }
            if (message.isFind) {
                const success = isLocationValid(message.locationReport.properties)
                const findStatus = `${success ? 'latest location is displayed on the map' : 'Tracker responded with weak gps signal'}`
                const pet = petFromIccid(message.iccid)
                recordFindResponse(pet, success, findStatus)
                setFindStatus(message.itemId, {msg: findStatus, date})
                setFindInProgress(message.itemId, false)
            }
            const status = Object.assign({}, message.deviceStatus)
            updateDeviceStatus(message.iccid, status)
        }
            break
        case'COMMAND_RESPONSE': {
            const status = Object.assign({}, message.deviceStatus)
            updateDeviceStatus(message.iccid, status)
            setLastEvent(message.iccid, message)
            if (message.commandResponse.command === 'FIND') {
                const success = isLocationValid(message.locationReport?.properties)
                const findStatus = `${success ? 'Location displayed on map' : 'No response from Tracker'}`
                const pet = petFromIccid(message.iccid)
                recordFindResponse(pet, success, findStatus)
                setTimeout(() => {
                    setFindStatus(message.itemId, {msg: findStatus, date})
                    setFindInProgress(message.itemId, false)
                }, 150)
            }
        }
            break
        case 'SAFE_ZONE': {
            const status = Object.assign({}, message.deviceStatus)
            updateDeviceStatus(message.iccid, status)
            // dataState.updateLastTenEvents(message.iccid, message)
        }
            break
        case 'DEVICE_UPDATE': {
            const status = Object.assign({}, message.deviceStatus)
            updateDeviceStatus(message.iccid, status)
            // a little hacky here
            if (message.deviceUpdate.subType !== 'DeviceStatusChanged') {
                setLastEvent(message.iccid, message)
            }
        }
            break
        case 'DEVICE_COMMAND_SENT': {
            if (message.deviceUpdate?.commandRequest?.cmd === 'FIND' || message.deviceUpdate?.commandRequest?.commandRequest?.cmd === 'FIND') {
                const petId = message.itemId
                setFindStatus(petId, {msg: 'Command sent to Gibi Tracker, awaiting reply', date})
                const pet = petFromIccid(message.iccid)
                findIsWaitingOnTracker(pet)
            }
        }
            break
        case 'FIND_RESPONSE': {
            const petId = message.itemId
            const success = message.commandResponse?.success
            const errorMessage = message.commandResponse?.errorMessage || ''
            let msg
            if (success) {
                msg = 'Location displayed on the map'
            } else if (errorMessage.toLowerCase().includes('invalid gps')) {
                msg = 'Tracker responded with weak GPS signal'
            } else if (errorMessage.toLowerCase().includes('timed out')) {
                msg = 'No response from Tracker (timed out)'
            } else {
                msg = errorMessage || 'Find failed'
            }
            setFindStatus(petId, {msg, date})
            const pet = dataState.pets.find(p => p._id === petId)
            recordFindResponse(pet!, success, msg)
            setFindInProgress(petId, false)
        }
            break
        default:
            break
    }
}
